const languageObj = {
  "HitPaw Online Audio Converter": "HitPaw محول الصوت عبر الإنترنت",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "قم بتحويل الصوتيات إلى تنسيقات MP3 و AAC و FLAC و WMA والمزيد مجانًا.",
  'HitPaw Online Image Converter': 'HitPaw محول الصور عبر الإنترنت',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'قم بتحويل الصور إلى تنسيقات JPG و PNG و BMP و TIFF والمزيد مجانًا.',
  'HitPaw Online Video Converter': 'محول الفيديو على الإنترنت  HitPaw',
  'Convert videos to any formats as your requirements.': 'قم بتحويل مقاطع الفيديو إلى أي تنسيقات حسب متطلباتك.',
  'Add More Files': 'إضافة المزيد من الملفات',
  'Convert to': 'تحويل إلى',
  'Ready': 'جاهز',
  'Converting': 'التحويل',
  'Video': 'فيديو',
  'Audio': 'صوتي',
  'Image': 'صورة',
  'Retry': 'أعد المحاولة',
  'Download All': 'تحميل الكل',
  'Download Desktop': 'تنزيل سطح المكتب',
  'Continue Editing': 'الاستمرار في التعديل',
  'Convert': 'تحول',
  'Cut': 'قطع',
  'Speed': 'السرعة',
  'Crop & Rotate': 'قص وتدوير',
  'Resize': 'تغيير الحجم',
  'Extract': 'استخراج',
  'Add Music': 'إضافة موسيقى',
  'Subtitles': 'العناوين الفرعية',
  'Merge': 'دمج',
  'Watermark Remover': 'إزالة العلامة المائية',
  'Add Watermark': 'إضافة علامة مائية',
  'Please select a file to use': 'الرجاء تحديد ملف لاستخدامه {{work}}',
  'Batch Processing': 'معالجة الدفعات',
};

export default languageObj